import "./adminDetailsEditComponent.scss";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import React, {useCallback, useEffect, useState} from "react";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import {CommonService} from "../../../../../shared/services";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import Grid from "@mui/material/Grid";
import FormikAutoCompleteDropdown
    from "../../../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import _ from "lodash";
import commonService from "../../../../../shared/services/common.service";
import LinkComponent from "../../../../../shared/components/link/LinkComponent";
import useRedirectUser from "../../../../../shared/hooks/useRedirectUser";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";


interface AdminDetailsEditComponentProps {
    onUpdateComplete: any;
    onEditCancel: any;
    facilityDetails: any;
}

const validationSchema = Yup.object({
    adminId: Yup.mixed().nullable()
    // .required('Required'),
});

interface FacilityAdminDetailsFormSchema {
    adminId: string,
}

const formInitialValues: FacilityAdminDetailsFormSchema = {
    adminId: "",
}

const AdminDetailsEditComponent = (props: AdminDetailsEditComponentProps) => {
    const {onUpdateComplete, facilityDetails, onEditCancel} = props;
    const {handleRedirectUserModule} = useRedirectUser();

    const [adminDetailsFormInitialValues, setAdminDetailsFormInitialValues] = useState<FacilityAdminDetailsFormSchema>(formInitialValues)
    const [facilityAdminsList, setFacilityAdminsList] = useState<any>([]);
    const [facilityAdminsListLoading, setFacilityAdminsListLoading] = useState<boolean>(false);
    const [facilityAdminListLoadingFailed, setFacilityAdminListLoadingFailed] = useState<boolean>(false);
    const [facilityAdminListLoaded, setFacilityAdminListLoaded] = useState<boolean>(false);


    const onFormSubmit = useCallback((values: any, {
        setSubmitting,
        setErrors,
    }: FormikHelpers<any>) => {
        const payload = {adminId: values.adminId?.id || null};
        CommonService._facility.editFacilityDetails(facilityDetails?.id, payload)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                onUpdateComplete(response?.data);
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                CommonService._alert.showToast('Error editing Admin details ', "success");
                setSubmitting(false);
            });
    }, [facilityDetails, onUpdateComplete]);

    const redirectUser = useCallback(() => {
        handleRedirectUserModule({type: 'facilityAdmin'})
    }, [handleRedirectUserModule])


    useEffect(() => {
        const facilityAdminDetails = facilityDetails?.adminDetails;
        if (facilityAdminDetails) {
            const adminDetailsObj = _.cloneDeep(facilityAdminDetails);
            setAdminDetailsFormInitialValues({adminId: adminDetailsObj});
        }
    }, [facilityDetails]);

    const getFacilityAdminsList = useCallback(() => {
        setFacilityAdminsListLoading(true);
        setFacilityAdminListLoaded(false);
        setFacilityAdminListLoadingFailed(false)
        commonService._facility.getFacilityAdminsList({})
            .then((response: IAPIResponseType<any>) => {
                setFacilityAdminsList(response.data);
                setFacilityAdminListLoaded(true);
                setFacilityAdminsListLoading(false);
            })
            .catch((error: any) => {
                setFacilityAdminListLoadingFailed(true);
                setFacilityAdminsListLoading(false);
            });
    }, [])

    useEffect(() => {
        getFacilityAdminsList();
    }, [getFacilityAdminsList]);

    return (
        <div className={'admin-details-edit-component details-tab-data-content'}>
            <Formik
                validationSchema={validationSchema}
                initialValues={adminDetailsFormInitialValues}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}
                onSubmit={onFormSubmit}
            >
                {({isSubmitting, resetForm, values, isValid, setFieldValue, validateForm, errors, dirty}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values]);
                    return (
                        <Form noValidate={true} className={"patient-personal-information-holder"}>
                            <div className={'t-form-controls-wrapper pdd-top-5'}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Field name={'adminId'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikAutoCompleteDropdown
                                                        label={'Facility Admin'}
                                                        placeholder={'Select Facility Admin'}
                                                        isDataLoaded={facilityAdminListLoaded}
                                                        isDataLoading={facilityAdminsListLoading}
                                                        isDataLoadingFailed={facilityAdminListLoadingFailed}
                                                        // required={true}
                                                        formikField={field}
                                                        data={facilityAdminsList}
                                                        valueKey={'id'}
                                                        getOptionLabel={(option => commonService.getFullName(option) || '')}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <div className="redirect-new-link-wrapper">
                                            <div>Didn't find admin?</div>
                                            <LinkComponent className={"redirect-link"}
                                                           onClick={redirectUser}>Create Admin</LinkComponent>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FeedbackComponent className={"mrg-top-10 mrg-bottom-10"}>
                                            Adding an admin is recommended, but if unavailable, it can be skipped
                                            and added later.
                                        </FeedbackComponent>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={"form-action-section-edit"}>
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"secondary"}
                                    type={"button"}
                                    variant={"outlined"}
                                    disabled={isSubmitting}
                                    handleClick={() => {
                                        onEditCancel();
                                    }}
                                    fullWidth={false}
                                >
                                    Cancel
                                </ButtonComponent>
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"primary"}
                                    type={"submit"}
                                    variant={"contained"}
                                    disabled={!(isValid && dirty)}
                                    fullWidth={false}
                                    isLoading={isSubmitting}
                                >
                                    Save
                                </ButtonComponent>
                            </div>
                        </Form>
                    )
                }
                }
            </Formik>
        </div>
    )
};

export default AdminDetailsEditComponent;
